<template lang="pug">
#app
  v-app
    theme-provider
    v-card.elevation-0(rounded="0" color="background")
      v-toolbar(color='white' dark='' flat='')
        v-toolbar-title.font-weight-700
          v-list(dense, color="white")
            v-list-item(to="/"  active-class="white white--text")
              v-list-item-title
                .d-flex.jc-center.ai-center
                  v-img(src="/static/logo.png", width="150")
                  v-spacer
                  v-chip.ml-3(color="primary" small)
                    small.font-size-11 Help Desk
        v-spacer
        v-tooltip(bottom='')
          template(v-slot:activator='{ on, attrs }')
            v-chip.pa-4(  v-bind='attrs' v-on='on' color='background  black--text')
              v-avatar( left)
                avatar-perfil(:usuario="username" :is-fetch="true")
              span.font-weight-700 {{nombre}}
          small.font-size-11 Perfil de tu cuenta
        v-tooltip(bottom='')
          template(v-slot:activator='{ on, attrs }')
            v-btn.mx-2(fab='' v-bind='attrs' v-on='on' dark='' small='' @click="logout()" color='primary')
              v-icon(dark='')
                | logout
          small.font-size-11 Cerrar sesión
        template(v-slot:extension='')
          v-tabs(v-model='tab' align-with-title='' background-color="primary")
            v-tabs-slider(color='white')
            v-tab(v-for='(item, index) in menu' :key='item.key' :to="item.path")
              | {{ item.name }}
      v-tabs-items
        .calc-height.background
          router-view
        notifications(position='top right', :class="isMovil ? 'width-full' : ''")
          template(slot='body' slot-scope='props')
            v-alert.elevation-2.py-3.ma-1.animated.fadeInRight.faster(dense border="left" :type='props.item.type')
              v-row(align='center')
                v-col.grow
                  small.font-size-11.font-weight-700 {{props.item.text}}
        loading-transaction(v-if="transaction.isProceso" :label="transaction.message")

  //- #app.display-flex.flex-direction-column.customer-container
  //-   .hero-head
  //-     header.nav
  //-       .container
  //-         .nav-left
  //-           a.nav-item(@click="goTo('/')")
  //-             img(src='/static/logo.png', alt='Logo')
  //-         .nav-center
  //-           .nav-item
  //-             span Help Desk
  //-         .nav-right.nav-menu
  //-           router-link.nav-item(to="/cliente") Clientes y equipos
  //-           a.nav-item(@click="logout") Salir
  //-   .hero-body
  //-     transition(name="fade")
  //-       router-view
  //-   notifications
</template>

<script>
import loadingTransaction from '@/components/c_loading_transaction'
import themeProvider from './components/c_theme_changer'
import avatarPerfil from '@/components/c_avatar_perfil'
import Router from './router/admin.js'
export default {
  name      : 'adminApp',
  components: {
    'theme-provider'     : themeProvider,
    'avatar-perfil'      : avatarPerfil,
    'loading-transaction': loadingTransaction
  },
  data () {
    return {
      tab  : null,
      perfil  : localStorage.getItem('perfil'),
      username: localStorage.getItem('username'),
      nombre: localStorage.getItem('nombre'),
      menu    : [
        {
          name: 'Dashboard',
          path: '/',
          icon: 'dashboard'
        },
        {
          name  : 'Auditoria',
          path  : '/auditoria',
          icon  : 'style',
          key   : 'auditoria',
          notify: ''
        },
        {
          name  : 'Notificaciones',
          path  : '/notificaciones',
          icon  : 'style',
          key   : 'notificaciones',
          notify: ''
        },
        {
          name  : 'Manager',
          path  : '/manager',
          icon  : 'cog',
          key   : 'manager',
          notify: ''
        }
      ]
    }
  },
  created () {
  },
  computed : {
    transaction () {
      var vm = this
      return vm.$store.state.app.transaction
    },
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    logout () {
      localStorage.clear()
      window.location.href = '/'
    },
    goTo (page) {
      Router.push(page)
    }
  }
}
</script>

<style  lang="stylus">
@import '~animate.css';
@import "./assets/css/main.styl"
.calc-height
  height: calc(100vh - 112px);
  overflow-y auto
  overflow-x hidden
hr
  margin 0 !important
.line-height-title
  line-height: 11px;
</style>



// WEBPACK FOOTER //
// Admin_App.vue?20499ef9